{
  "nl": {
    "todo_list": {
      "actions": {
        "add": "Takenlijst toevoegen",
        "cancel": "Cancel",
        "delete_todo_list": "Verwijder takenlijst",
        "edit": "Bewerken",
        "new": "Takenlijst",
        "save": "Opslaan",
        "title": "Takenlijst titel"
      },
      "attributes": {
        "name": "Titel"
      },
      "labels": {
        "assignToLevel": "Toewijzen aan level",
        "createdAt": "Gemaakt op",
        "filter_employee": "Verantwoordelijke",
        "newTodoList": "Nieuwe takenlijst",
        "sort": {
          "created_at_asc": "Oudste eerst",
          "created_at_desc": "Nieuwste eerst",
          "name_lower_asc": "Titel A -> Z",
          "name_lower_desc": "Titel Z -> A"
        }
      },
      "placeholders": {
        "employees": {
          "new": {
            "subtitle": "Behoud overzicht in wat jou en jouw team te doen staat.",
            "title": "Maak een nieuwe takenlijst"
          }
        }
      },
      "toasts": {
        "create": "Takenlijst aangemaakt",
        "delete": "Takenlijst verwijderd",
        "update": "Takenlijst gewijzigd"
      },
      "validation": {
        "needTitle": "Titel vereist"
      }
    }
  }
}